import React from 'react';
import { ArrowBigDown } from 'lucide-react';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-24 md:pt-32 pb-16 md:pb-24 hero-pattern">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center animated-section">
          <div className="mb-8 rounded-full bg-primary/10 p-4">
            <ArrowBigDown 
              className="text-primary w-12 h-12 md:w-16 md:h-16" 
              strokeWidth={2} 
            />
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 max-w-3xl">
            Building a Better Future Together
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-8">
            Arrow Drop Foundation (ADF-NGO) is committed to making a positive impact in our community.
            We're working towards creating meaningful change for a better tomorrow through education, 
            skill development, and social welfare initiatives.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <button 
              onClick={() => scrollToSection('mission')}
              className="px-6 py-3 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-gray-900"
            >
              Learn More
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-6 py-3 rounded-md bg-secondary text-secondary-foreground hover:bg-secondary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 dark:focus:ring-offset-gray-900"
            >
              Contact Us
            </button>
          </div>

          {/* Key Features/Keywords for SEO */}
          <div className="flex flex-wrap justify-center gap-2 text-sm text-muted-foreground">
            <span className="px-3 py-1 bg-primary/10 rounded-full">ADF-NGO</span>
            <span className="px-3 py-1 bg-primary/10 rounded-full">Arrow Foundation</span>
            <span className="px-3 py-1 bg-primary/10 rounded-full">Drop Foundation</span>
            <span className="px-3 py-1 bg-primary/10 rounded-full">Social Development</span>
            <span className="px-3 py-1 bg-primary/10 rounded-full">Education NGO</span>
            <span className="px-3 py-1 bg-primary/10 rounded-full">Skill Development</span>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background to-transparent"></div>
    </section>
  );
};

export default Hero